<template>
  <div class="columns">
    <div class="column is-6">
      <div>
        <p class="detail-links">Para baixar os modelos de tabelas Intelipost, acesse os tutoriais de cada modelo:</p>
        <div class="columns">
          <div class="column is-12">
            <sc-icon icon="download" class="icon-form"/>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://intercom.help/intelipost/pt-BR/articles/5527340-orientacoes-sobre-a-tabela-de-frete-modelo-intelipost-v2-5"
              class="links-form">
              Baixar Intelipost Modelo 2.5
            </a>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <sc-icon icon="download" class="icon-form"/>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://intercom.help/intelipost/pt-BR/articles/5527328-orientacoes-sobre-a-tabela-de-frete-modelo-intelipost-v3-0"
              class="links-form">
              Baixar Intelipost Modelo 3.0 (multi origens)
            </a>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <sc-icon icon="download" class="icon-form"/>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://intercom.help/intelipost/pt-BR/articles/5527342-orientacoes-para-preenchimento-da-tabela-de-frete-modelo-intelipost-omnichannel"
              class="links-form">
              Baixar Intelipost Omnichannel (por raio de KM)
            </a>
          </div>
        </div>
      </div>
      <div>
        <p class="title-company is-5">Formato da tabela <b class="required">*</b></p>
        <sc-field prop="quote_table_type">
          <div class="block">
            <sc-radio
              v-for="types in quoteTableTypes"
              :key="types.id"
              v-model="value.quote_table_type"
              :native-value="`${types.description} - ${types.subDescription}`"
              class="radio-item"
              @input="handleRadioChange">
              <label>{{types.description}}</label>
              <p>{{ types.subDescription }}</p>
            </sc-radio>
          </div>
        </sc-field>
        <div class="block-desc-table" 
          v-if="value.quote_table_type ==='Padrão Transportadora - Validação comercial + 8 dias úteis para implantação'">
          <p class="title-details-table">
            <sc-icon 
              class="icon-form" 
              icon="exclamation-circle"/>
            Atenção para Padrão Transportadora:
          </p>
          <ol class="list-table">
            <li>Abrangência (UF + cidades + prazos + regiões)</li>
            <li>Tarifário (Preços + Taxas + Regiões)</li>
          </ol>
          <p class="list-details-table">* Caso as faixas de CEP não forem enviadas juntamente com o arquivo de abrangência, usaremos as faixas de CEP padrão dos correios.</p>
          <p class="list-details-table">* As regiões devem ser coerentes entre os dois arquivos para que possam ser associados.</p>
        </div>
        <div class="block-desc-table" 
        v-if="value.quote_table_type ==='Padrão Contingência Intelipost - 2 dias úteis para implantação'">
          <p class="title-details-table">Atenção para Padrão Contingência Intelipost:</p>
          <p>A tabela de contingência é uma tabela de frete simplificada, que é ativada automaticamente caso ocorra indisponibilidade generalizada do serviço de cotação na Intelipost.</p>
        </div>
        <div v-if="value.quote_table_type ==='InteliEnvios - Validação comercial + 2 dias úteis para implantação'">
          <p>Transportadora desejada <b class="required">*</b></p>
          <sc-field prop="inteli_envios_lp">
            <sc-multiple-selection
              v-model="value.inteli_envios_lp"
              :options="inteliEnviosLp"
              @clearFilter="() => value.inteli_envios_lp = []"
              @selectAll="(values) => value.inteli_envios_lp = values" />
          </sc-field>
        </div>
      </div>
    </div>

    <div class="column is-6">
      <div>
        <p class="title-company is-5">Formato adicional (+Intelipost) <b class="required">*</b></p>
        <div class="block">
          <sc-radio
            v-for="types in additionalTableType"
            :key="types.id"
            v-model="value.additional_table_type"
            :native-value="types.id"
            class="radio-item"
            @input="handleRadioChange">
            <label>{{types.description}}</label>
            <p>{{ types.subDescription }}</p>
          </sc-radio>
        </div>
        <div v-if="value.additional_table_type === 'LINX'" @click="clearValidation">
          <sc-field label="Selecione o tipo (LINX):" prop="linx_type">
            <sc-select
              v-model="value.linx_type">
              <option  
                v-for="types in linxTypeList"
                :value="types.value"
                :key="types.key">
                {{ types.label }}
              </option>
            </sc-select>
          </sc-field>
        </div>
        <div v-if="value.additional_table_type === 'VTEX'">
          <sc-field label="CEP Origem (VTEX)" prop="vtex_origin_zip_code">
            <sc-input 
              placeholder="Formato: 00000-000 ou 00000000"
              v-model="value.vtex_origin_zip_code"
              v-mask="'cep'"
              type="text">
            </sc-input>
          </sc-field>
        </div>
      </div>
      <div>
        <p class="title-company is-5">Origem <b class="required">*</b></p>
        <sc-field>
          <div class="block">
            <sc-radio
              v-for="types in originType"
              :key="types.id"
              v-model="value.origin_type"
              :native-value="types.description"
              class="radio-item"
              @input="handleRadioChange">
              <label>{{types.description}}</label>
          </sc-radio>
          </div>
        </sc-field>
        <div v-if="value.origin_type && getOriginType && getOriginType.showWarehouseFields">
          <sc-field label="CEP Inicial:" prop="warehouse_initial_zip_code">
          <sc-input 
            placeholder="Formato: 00000-000 ou 00000000"
            v-model="value.warehouse_initial_zip_code"
            type="text"
            v-mask="'cep'">
          </sc-input>
        </sc-field>
        <sc-field label="CEP Final:" prop="warehouse_final_zip_code">
          <sc-input 
            placeholder="Formato: 00000-000 ou 00000000"
            v-model="value.warehouse_final_zip_code"
            type="text"
            v-mask="'cep'">
          </sc-input>
        </sc-field>
        </div>
      </div>

      <div>
        <p class="title-company is-5">Replicar em outra conta Intelipost?</p>
        <sc-field label="Id de cada conta" prop="client_ids_to_replicate">
          <sc-input 
            placeholder="Separe o ID de cada conta com vírgula (ID,ID,ID). Acima de 250 caracteres, incluir no campo de Outros comentários relevantes"
            v-model="value.client_ids_to_replicate"
            type="text">
          </sc-input>
        </sc-field>
      </div>
    
      <div class="block-attachment">
        <sc-field label="Anexos" prop="files">
          <sc-upload
            v-model="files"
            drag-drop
            multiple
            @input="onInput">
              <section class="upload">
                <p>
                  <sc-icon
                    icon="upload"
                    size="is-small"/>
                    Arraste um arquivo ou <b>clique</b> para buscar.
                </p>
              </section>
          </sc-upload>
        </sc-field>
        <span class="file-details" v-for="quote_table_file in this.value.quote_table_files" :key="quote_table_file.file_name">
          {{ quote_table_file.file_name }}
          <sc-button class="delete"
              type="button"
              @click="deleteDropFile(quote_table_file)">
          </sc-button>
        </span>
        <div class="details-attachment">
          <p>Formatos permitidos: .csv , .xlsx </p>
          <p>Preço e Generalidades : Tabela com a negociação comercial.</p>
          <p>Abrangência e Prazos : Tabela de abrangência de cidades atendidas com praças e prazos de entrega. </p>
          <p>TDE, TDA & TRT : Lista de cidades ou CNPJs com cobrança de TDE, TDA, TRT.  </p>
          <p>Outras relações : idades Fluviais, Suframa, Taxa de Segurança de Balsa, etc.</p>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import { createNamespacedHelpers } from 'vuex';
import {
    ScPageBase,
    ScForm,
    ScInput,
    ScField,
    ScButton,
    ScSelect,
    ScRadio,
    ScCheckbox,
    ScSwitch,
    ScMultipleSelection,
    ScUpload,
    ScIcon,
  } from '@intelipost-js/secure-components';

const { mapState, mapActions, mapMutations } = createNamespacedHelpers(
  'integrations/integrationsAppSelfService',
);

export default {
  name: 'new-quote-table-form',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      selectedType: null,
      files: null,
    };
  },

  computed: {
    ...mapState([
      'loading',
    ]),
    quoteTableTypes() {
      return [
        {
          id: 'PADRAO_TRANSPORTADORA',
          description: 'Padrão Transportadora',
          subDescription: 'Validação comercial + 8 dias úteis para implantação',
        },
        {
          id: 'INTELIPOST_2_5',
          description: 'Padrão Intelipost V2.5',
          subDescription: 'Validação comercial + 1 dia útil para implantação',
        },
        {
          id: 'INTELIENVIOS',
          description: 'InteliEnvios',
          subDescription: 'Validação comercial + 2 dias úteis para implantação',
        },
        {
          id: 'OMNICHANNEL',
          description: 'Padrão Intelipost Omnichannel',
          subDescription: 'Validação comercial + 8 dias úteis para implantação',
        },
        {
          id: 'INTELIPOST_3_0',
          description: 'Padrão Intelipost V3.0',
          subDescription: 'Validação comercial + 1 dia útil para implantação',
        },
        {
          id: 'CONTINGENCIA',
          description: 'Padrão Contingência Intelipost',
          subDescription: '2 dias úteis para implantação',
        },
      ];
    },
    additionalTableType() {
      return [
        {
          id: 'NONE',
          description: 'Nenhum',
        },
        {
          id: 'VTEX',
          description: 'VTEX',
          subDescription: 'Tabela será gerada e enviada ao solicitante no formato VTEX',
        },
        {
          id: 'LINX',
          description: 'LINX',
          subDescription: 'Tabela será exportada no formato LINX',
        },
      ];
    },
    linxTypeList() {
      return {
        STANDARD: {
          label: 'Standard',
          value: 'Standard',
        },
        EXPRESS: {
          label: 'Express',
          value: 'Express',
        },
        SHIP_TO: {
          label: 'ShipTo',
          value: 'ShipTo',
        },
        SHIP_FROM_STD: {
          label: 'ShipFrom: Standard',
          value: 'ShipFrom: Standard',
        },
        SHIP_FROM_EXPRESS: {
          label: 'ShipFrom: Express',
          value: 'ShipFrom: Express',
        },
        GARANTIDA: {
          label: 'Garantida',
          value: 'Garantida',
        },
        SCHEDULE: {
          label: 'Schedule',
          value: 'Schedule',
        },
      };
    },
    originType() {
      return [
        {
          id: 'UNIQUE_WAREHOUSE',
          description: 'Centro de Distribuição Único',
          showWarehouseFields: false,
        },
        {
          id: 'WAREHOUSE_STORE',
          description: 'Centro de Distribuição / Loja',
          showWarehouseFields: true,
        },
      ];
    },
    inteliEnviosLp() {
      return {
        CARRIERS: {
          label: 'Carriers',
          value: 'Carriers',
        },
        LOGGI: {
          label: 'Loggi',
          value: 'Loggi',
        },
        MD_TRANSLOG: {
          label: 'MD Translog',
          value: 'MD Translog',
        },
        PEGAKI: {
          label: 'Pegaki',
          value: 'Pegaki',
        },
        GFL: {
          label: 'GFL',
          value: 'GFL',
        },
        ENTREGAS_JA: {
          label: 'Entregas Já',
          value: 'Entregas Já',
        },
      };
    },
    getOriginType() {
      return this.originType.find(type => type.description === this.value.origin_type);
    },
  },

  methods: {
    ...mapActions([
      'lpAttachTemporaryFile',
    ]),
    ...mapMutations([
      'setLoading',
    ]),
    async onInput(files) {
      this.setLoading(true);
      const newFiles = files.filter(file => this.isNewFile(file));
      const results = await Promise.all(newFiles.map(file => this.sendFile(file)));
      this.value.quote_table_files = [
        ...this.value.quote_table_files,
        ...results,
      ];
      this.setLoading(false);
    },
    isNewFile(file) {
      return !this.value.quote_table_files.find(quote_file => quote_file.file_name === file.name);
    },
    async sendFile(file) {
      const base64 = await this.toBase64(file);
      const args = {
        base64,
        file_name: file.name,
        content_type: file.type,
      };
      const result = await this.lpAttachTemporaryFile(args);
      return {
        id: result.temporary_attachment_id,
        file_name: file.name,
      };
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split('base64,')[1]);
        reader.onerror = error => reject(error);
      });
    },
    deleteDropFile(quote_table_file) {
      const name = quote_table_file.file_name;
      this.value.quote_table_files = this.value.quote_table_files
        .filter(file => file.file_name !== name);
      this.files = this.files
        .filter(file => file.name !== name);
    },
    emitInput() {
      this.$emit('input', this.value);
    },
    clearValidation() {
      this.clearValidateRules();
    },

    handleRadioChange() {
      if (this.value.quote_table_type !== 'INTELIENVIOS') {
        this.value.inteli_envios_lp = [];
      }
      if (this.value.additional_table_type !== 'VTEX') {
        this.value.vtex_origin_zip_code = '';
      }
      if (this.value.additional_table_type !== 'LINX') {
        this.value.linx_type = '';
      }
      if (this.value.origin_type !== 'Centro de Distribuição / Loja') {
        this.value.warehouse_final_zip_code = '';
        this.value.warehouse_initial_zip_code = '';
      }
    },
  },

  mounted() {
  },

  components: {
    ScInput,
    ScField,
    ScForm,
    ScPageBase,
    ScButton,
    ScSelect,
    ScRadio,
    ScSwitch,
    ScCheckbox,
    ScMultipleSelection,
    ScUpload,
    ScIcon,
  },
};
</script>

<style lang="scss">
  @import "~@intelipost-js/secure-ui/src/scss/variables";
  
  $primary-form: #3670d6;

  .icon.icon-form {
    color: $primary-form;
    font-size: .75rem;
  }
  .upload {
    padding-top: 15px;
    padding-bottom: 15px;
    text-align: center;
  }
  .links-form {
    color: $primary-form;

    &:hover {
      color: $primary-form;
    }
  }
  .title-company {
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.16px;
    color: #010906;
    margin-top: 15px;
    margin-bottom: 10px;
  }
  .title-details-table {
    font-weight: bold;
  }
  .list-details-table {
    color: gray;
    margin-top: 10px;
  }
  .list-table {
    list-style-type: disc;
    margin-left: 20px;
    margin-top: 10px;
  }
  .block-desc-table {
    border: 1px solid $primary-form;
    border-radius: 10px;
    padding: 15px;
    margin-top: 20px;
  }
  .block-attachment {
    margin-top: 10px;
  }
  .block {
    display: flex;
    flex-direction: column;
  }

  .radio-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .radio-item label {
    color: black;
    font-size: 1.1rem;
  }
  .radio-item p {
    color: gray;
  }
  .details-attachment {
    color: gray;
    margin-top: 20px;
    
  }
  .detail-links {
    font-size: 1.1rem;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  .b-radio.radio.radio-item 
    input[type=radio]+.check {
      border-radius: 38%;
      border: 2px solid gray;

    &::before {
      background-color: $link;
    }
  }
  .delete {
    background-color: $primary !important;
    border: $primary;
  }
  .file-details {
    border: 1px solid $primary;
    padding: 5px;
    font-size: 1rem;
  }

</style>
  


// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/add-delivery-method/NewQuoteTableForm.vue